module.exports = __webpack_public_path__ + "media/running_touchdown_left.65a8ee29.mp4";